module.exports = __webpack_public_path__ + "static/img/point_to.82f1b20.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/module/dataIndex/static/point_to.png
// module id = BFVP
// module chunks = 60